import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engineering-and-construction',
  templateUrl: './engineering-and-construction.component.html',
  styleUrls: ['./engineering-and-construction.component.scss']
})
export class EngineeringAndConstructionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
